export default distance => {
  const numberValue =
    distance >= 1000 ? Math.round((distance / 1000) * 10) / 10 : distance
  const unit = distance >= 1000 ? 'km' : 'm'

  return `${numberValue} ${unit}`
}
